// deps
import React, { memo } from "react";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// constants
import { NO_ITEMS_ADDED, NO_ITEMS_ADDED_YET } from "@cart-ui/constants/GroupCart";

// styles
import { Container } from "./NoItems.style";

interface IProps {
    isCurrentItemFromSameUser: boolean;
}

const NoItems = ({ isCurrentItemFromSameUser }: IProps) => {
    return (
        <Container>
            <Text variant="V2.body2.neutral.medium" color="text_Low_Emphasis">
                {isCurrentItemFromSameUser ? NO_ITEMS_ADDED_YET : NO_ITEMS_ADDED}
            </Text>
        </Container>
    );
};

export default memo(NoItems);
